<template>
  <div class="teleport">
    <slot></slot>
  </div>
</template>

<script setup>
import { onMounted, getCurrentInstance, ref, onBeforeUnmount } from "vue";

defineProps({
  to: {
    type: String,
    required: true,
  },
});

const nodes = ref([]);

let parent = null;

const createFragment = () => {
  const fragment = document.createDocumentFragment();
  nodes.value.forEach((x) => fragment.appendChild(x));
  return fragment;
};

const App = getCurrentInstance()?.proxy;

onBeforeUnmount(() => {
  nodes.value.forEach((x) => parent.removeChild(x));
});

onMounted(() => {
  nodes.value = Array.from(App.$el.childNodes);

  parent = document.querySelector(App.to);
  parent.appendChild(createFragment());
});
</script>

<style lang="less" scoped></style>
